import DataLoadError from '@/components/errors/DataLoadError';
import {
  type ApiQueryError,
  shouldShowDataLoadError
} from '@/app/common/utils/apiErrorUtils';

type ApiLoadErrorProps = {
  error?: ApiQueryError;
  isError?: boolean;
  onRetry: () => void;
  isRetrying?: boolean;
  compact?: boolean;
  className?: string;
};

const ApiLoadError = ({
  error,
  isError = true,
  onRetry,
  isRetrying = false,
  compact = false,
  className = '',
}: ApiLoadErrorProps) => {
  if (!shouldShowDataLoadError(isError, error)) {
    return null;
  }

  return (
    <DataLoadError
      error={error}
      onRetry={onRetry}
      isRetrying={isRetrying}
      compact={compact}
      className={className}
    />
  );
};

export default ApiLoadError;
